// extracted by mini-css-extract-plugin
module.exports = {"root":"Spacer_root__2kLFX","sm":"Spacer_sm__14i20","md":"Spacer_md__3rSvB","lg":"Spacer_lg__2h9Vb"};